import { type RouteObject, createBrowserRouter, redirect } from 'react-router-dom';
import { languages } from '@/i18n/config';
import { getDetectedLanguage } from '@/i18n/detected';

import Home from '@/pages/Home';
import Error404 from '@/components/error/404';
import Error500 from '@/components/error/500';
import AppLayout from '../App';

import { eventRoutes } from './events';
import { calendarRoutes } from './calendar';
import { exploreRoutes } from './explore';
import { mapRoutes } from './map';
import { tagRoutes } from './tag';
import { organizerRoutes } from './organizer';
import { favoritesRoutes } from './favorites';
import { customPages } from './page';
import { itineraryRoutes } from './itinerary';

export const router = createBrowserRouter([
  {
    path: '/:lang',
    element: <AppLayout />,
    loader: async ({ request }) => {
      const path = new URL(request.url).pathname;
      const firstSegment = path?.split('/')?.[1] || '';
      const isValidLang = languages.includes(firstSegment);

      if (!isValidLang) {
        const resolved = await getDetectedLanguage();
        const search = new URL(request.url)?.searchParams?.toString();
        const safeSearch = search ? `?${search}` : '';
        return redirect(`/${resolved}${path}${safeSearch}`);
      }
      return null;
    },
    children: [
      {
        errorElement: <Error404 />,
        children: (
          [
            {
              path: '',
              element: <Home />,
              errorElement: <Error500 />,
            },
          ] as RouteObject[]
        ).concat(
          eventRoutes,
          calendarRoutes,
          exploreRoutes,
          tagRoutes,
          organizerRoutes,
          favoritesRoutes,
          customPages,
          itineraryRoutes
        ),
      },
    ],
  },
  {
    path: '/:lang',
    element: <AppLayout footer='mini' />,
    children: [
      {
        errorElement: <Error404 />,
        children: mapRoutes,
      },
    ],
  },
  {
    path: '/',
    loader: async ({ request }) => {
      const resolved = await getDetectedLanguage();
      const search = new URL(request.url)?.searchParams?.toString();
      const safeSearch = search ? `?${search}` : '';
      return redirect(`/${resolved}${safeSearch}`);
    },
  },
  {
    path: '*',
    element: <AppLayout />,
    loader: async ({ request }) => {
      const path = new URL(request.url).pathname;
      const firstSegment = path?.split('/')?.[1] || '';
      const isValidLang = languages.includes(firstSegment);

      if (!isValidLang) {
        const resolved = await getDetectedLanguage();
        const search = new URL(request.url)?.searchParams?.toString();
        const safeSearch = search ? `?${search}` : '';
        return redirect(`/${resolved}${path}${safeSearch}`);
      }
      return null;
    },
    children: [
      {
        path: '*',
        element: <Error404 />,
      },
    ],
  },
]);
